import { useMemo } from 'react';
import { useTranslator } from '$hooks/useTranslator';

export const usePayFormTranslations = (isTrial = false) => {
  const t = useTranslator();
  return useMemo(
    () => ({
      texts: {
        failedPaymentScreen: {
          title: t('pay_form_unknown_error'),
        },
        paymentForm: {
          buttonPayLabel: t('pay_form_pay'),
          cardholderLabel: t('pay_form_card_holder'),
          cardholderPlaceholder: t('pay_form_card_holder_placeholder'),
          cardNumberLabel: t('pay_form_card_number'),
          expireDateLabel: t('pay_form_expiry_date'),
          expireDateNote: t('pay_form_date_note'),
          expireDatePlaceholder: t('pay_form_expiry_date_placeholder'),
          recurrentLabel: t('pay_form_accept_recurring_payments'),
          termsAgreement: `${
            isTrial ? t('pay_form_terms_agreement_trial') : t('pay_form_terms_agreement')
          } {{#link}}${t('pay_form_terms_agreement_link')}{{/link}}`,
          validationErrors: {
            INVALID_CARD_NUMBER: t('pay_form_invalid_card_number'),
            INVALID_CVV: t('pay_form_invalid_code'),
            INVALID_EXPIRY_DATE: t('pay_form_invalid_date'),
            IS_REQUIRED: t('pay_form_required_field'),
          },
        },
        paymentProcessScreen: {
          description: t('pay_form_payment_in_progress_desc'),
          title: t('pay_form_payment_in_progress'),
        },
        redirectionScreen: {
          followTheLink: `${t('pay_form_redirect_to_bank_desc')} {{#link}}${t(
            'pay_form_redirect_to_bank_link',
          )}{{/link}}.`,
          title: t('pay_form_payment_in_progress'),
          waitForRedirectToBanksPage: `${t(
            'pay_form_redirect_to_bank_after',
          )} {{#strong}}{{count}} ${t('pay_form_redirect_to_bank_count')}{{/strong}} ${t(
            'pay_form_redirect_to_bank_will_redirect',
          )}`,
        },
        successPaymentScreen: {
          title: t('pay_form_success_title'),
        },
        transactionData: {
          amountLabel: t('pay_form_transaction_data_amount'),
          creditCardLabel: t('pay_form_transaction_data_credit_card'),
          transactionIdLabel: t('pay_form_transaction_data_transaction_id'),
        },
        unknownError: t('pay_form_unknown_error_desc'),
      },
    }),
    [t],
  );
};
